import React from 'react';
import useTitle from '../../Hooks/useTitle';

const Blog = () => {
    useTitle("Blog");
    return (
        <div className='px-5 md:px-20 lg:px-32 py-10 max-w-[1400px] m-auto'>
            <h1 className='text-center text-4xl font-bold tracking-widest'>Blog</h1>
            <div className='min-h-[60vh] flex items-center justify-center'>
                <p className='flex items-center gap-2 text-xl font-bold justify-center'>Comming soon <span className="loading text-accent loading-dots"></span></p>
            </div>
        </div>
    );
};

export default Blog;